export const columnOptions = {
    slidesPerView: 2.6,
    spaceBetween: 20,
    speed: 1200,
    breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 0 },
        768: { slidesPerView: 1.4, spaceBetween: 20 },
        992: { slidesPerView: 2.6, spaceBetween: 20 },
    },
}

export const carDetailsV23 = {
    // banner: {
    //     title: '',
    //     introduce: '',
    //     img: require('@/assets/img/carDetails/V23/banner1.webp'),
    //     img_mobile: require('@/assets/img/carDetails/V23/banner1_mobile2.webp'),
    // },
    // carColumn: [
    //     {
    //         id: 1,
    //         title: '極致後排空間',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V23/column/1.webp'),
    //     },
    //     {
    //         id: 2,
    //         title: '獨特設計機械旋鈕',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V23/column/2.webp'),
    //     },
    //     {
    //         id: 3,
    //         title: '生而愛玩',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V23/column/3.webp'),
    //     },
    //     {
    //         id: 4,
    //         title: '獨特設計',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V23/column/4.webp'),
    //     },
    // ],
    // switch: [
    //     {
    //         id: 1,
    //         title: '',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V23/switch/1.webp'),
    //         img_mobile: require('@/assets/img/carDetails/V23/switch/1_mobil.webp'),
    //     },
    //     {
    //         id: 2,
    //         title: '',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V23/switch/2.webp'),
    //         img_mobile: require('@/assets/img/carDetails/V23/switch/2_mobil.webp'),
    //     },
    //     // {
    //     //     id: 3,
    //     //     title: '',
    //     //     introduce: '',
    //     //     img: require('@/assets/img/carDetails/V23/switch/3.webp'),
    //     // },
    // ],
    // pages: [
    //     {
    //         id: 1,
    //         title: '硬朗外觀，精准',
    //         introduce: '複古經典',
    //         img: require('@/assets/img/carDetails/V23/page3.webp'),
    //         img_mobile: require('@/assets/img/carDetails/V23/page3_mobile.webp'),
    //     },
    //     {
    //         id: 2,
    //         title: '壹見鍾情',
    //         introduce: '隨時隨地，成爲焦點',
    //         img: require('@/assets/img/carDetails/V23/page4.webp'),
    //         img_mobile: require('@/assets/img/carDetails/V23/page4_mobile.webp'),
    //     },
    //     {
    //         id: 3,
    //         title: '這是與你共創的夥伴，由你來定義',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V23/page6.webp'),
    //         img_mobile: require('@/assets/img/carDetails/V23/page6_mobile.webp'),
    //     },
    // ],
    // switchColors: [
    //     {
    //         id: 1,
    //         title: '',
    //         introduce: '',
    //         colorBg: 'color-orange',
    //         colorText: '橙',
    //         colorBorder: '#da5301',
    //         img: require('@/assets/img/carDetails/V23/colors/car1.webp'),
    //     },
    //     {
    //         id: 2,
    //         title: '',
    //         introduce: '',
    //         colorBg: 'color-white',
    //         colorText: '白',
    //         colorBorder: '#f9f9f9',
    //         img: require('@/assets/img/carDetails/V23/colors/car2.webp'),
    //     },
    //     {
    //         id: 3,
    //         title: '',
    //         introduce: '',
    //         colorBg: 'color-silver',
    //         colorText: '銀',
    //         colorBorder: '#b4b7bf',
    //         img: require('@/assets/img/carDetails/V23/colors/car3.webp'),
    //     },
    //     {
    //         id: 4,
    //         title: '',
    //         introduce: '',
    //         colorBg: 'color-black',
    //         colorText: '黑',
    //         colorBorder: '#1c1c1c',
    //         img: require('@/assets/img/carDetails/V23/colors/car4.webp'),
    //     },
    //     {
    //         id: 5,
    //         title: '',
    //         introduce: '#666',
    //         colorBg: 'color-gray',
    //         colorText: '灰',
    //         colorBorder: '#666',
    //         img: require('@/assets/img/carDetails/V23/colors/car5.webp'),
    //     },
    //     {
    //         id: 6,
    //         title: '',
    //         introduce: '',
    //         colorBg: 'color-green',
    //         colorText: '綠',
    //         colorBorder: '#4e523b',
    //         img: require('@/assets/img/carDetails/V23/colors/car6.webp'),
    //     },
    // ],
    parameters: [
        {
            specification: '類型',
            classic: '',
            premium: 'BEV SUV',
        },
        {
            specification: '長x寬x高(mm)',
            classic: '',
            premium: '4220×1915×1845',
        },
        {
            specification: '軸距(mm)',
            classic: '',
            premium: '2735',
        },
        {
            specification: '電機類型',
            classic: '永磁同步',
            premium: '永磁同步 + 交流異步',
        },
        {
            specification: '最大功率(kW)',
            classic: '100',
            premium: '155',
        },
        {
            specification: '最大扭矩(N·m)',
            classic: '180',
            premium: '292',
        },
        {
            specification: '電池容量(kWh)',
            classic: '59.93',
            premium: '81.76',
        },
    ],
    // latePage: [
    //     {
    //         id: 4,
    //         title: '黃金REEV系統',
    //         introduce: '加速性能更快：0-100km/h加速僅需5.9秒 \n靜谧體驗升級：<61dB，低于行業標准2dB',
    //         img: require('@/assets/img/carDetails/V27/last/4.webp'),
    //     },
    //     {
    //         id: 5,
    //         title: '後方交叉來車預警（RCTA）',
    //         introduce: '倒車時監測橫向來車，風險即時聲光預警，盲區防護助力從容操作',
    //         img: require('@/assets/img/carDetails/V27/last/5.webp'),
    //     },
    //     {
    //         id: 6,
    //         title: '自動泊車',
    //         introduce: '智能車位識別與路徑規劃，全自動泊車，即使在狹小空間也能精准定位，輕松完成泊車',
    //         img: require('@/assets/img/carDetails/V27/last/6.webp'),
    //     },
    //     {
    //         id: 7,
    //         title: '超高剛性車身',
    //         introduce: '高強度籠式車身扭轉剛度達32,186 N·m/deg，兼顧安全性、耐用性與操控品質。',
    //         img: require('@/assets/img/carDetails/V27/last/7.webp'),
    //     },
    // ]
}




export const carDetailsV27 = {
    // banner: {
    //     title: '全能混動SUV',
    //     introduce: '經典造型，電驅動力',
    //     img: require('@/assets/img/carDetails/V27/hero-section-2(1).webp'),
    //     img_mobile: require('@/assets/img/carDetails/V27/hero-section-2(1).webp'),
    // img_mobile: require('@/assets/img/carDetails/V27/hero-section-2(2).webp'),
    // },
    // carColumn: [
    //     {
    //         id: 1,
    //         title: '經典方正造型',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V27/column/1.webp'),
    //     },
    //     {
    //         id: 2,
    //         title: '複古與科技的融合',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V27/column/2.webp'),
    //     },
    //     {
    //         id: 3,
    //         title: '精致表面',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V27/column/3.webp'),
    //     },
    // ],
    // switch: [
    //     {
    //         id: 1,
    //         title: '五星安全，無畏前行',
    //         introduce: '符合E-NCAP、C-NCAP、A-NCAP、ASEAN NCAP等全球主流機構五星安全標准\n高刚性纵向笼式车身\n11條橫梁與11條縱梁構成籠式結構\n39個關鍵部位采用熱成型鋼\n76.53%高強度鋼與鋁合金占比\n全車底部防護',
    //         img: require('@/assets/img/carDetails/V27/switch/1.jpg'),
    //         img_mobile: require('@/assets/img/carDetails/V27/switch/1.jpg'),
    //     },
    //     {
    //         id: 2,
    //         title: '全地形通過能力',
    //         introduce: '接近角24°、離去角23°，涉水深度600mm，輕松應對複雜路況。',
    //         img: require('@/assets/img/carDetails/V27/switch/2.jpg'),
    //         img_mobile: require('@/assets/img/carDetails/V27/switch/2.jpg'),
    //     },
    //     {
    //         id: 3,
    //         title: '恢弘車身尺寸',
    //         introduce: '恢弘的車身尺度帶來震撼視覺沖擊，也爲寬敞',
    //         img: require('@/assets/img/carDetails/V27/switch/3.jpg'),
    //         img_mobile: require('@/assets/img/carDetails/V27/switch/3.jpg'),
    //     },
    //     // {
    //     //     id: 4,
    //     //     title: '黃金REEV系統',
    //     //     introduce: '加速性能更快：0-100km/h加速僅需5.9秒 \n靜谧體驗升級：<61dB，低于行業標准2dB',
    //     //     img: require('@/assets/img/carDetails/V27/switch/4.webp'),
    //     // },
    //     // {
    //     //     id: 5,
    //     //     title: '後方交叉來車預警（RCTA）',
    //     //     introduce: '倒車時監測橫向來車，風險即時聲光預警，盲區防護助力從容操作',
    //     //     img: require('@/assets/img/carDetails/V27/switch/5.webp'),
    //     // },
    //     // {
    //     //     id: 6,
    //     //     title: '自動泊車',
    //     //     introduce: '智能車位識別與路徑規劃，全自動泊車，即使在狹小空間也能精准定位，輕松完成泊車',
    //     //     img: require('@/assets/img/carDetails/V27/switch/6.webp'),
    //     // },
    //     // {
    //     //     id: 7,
    //     //     title: '超高剛性車身',
    //     //     introduce: '高強度籠式車身扭轉剛度達32,186 N·m/deg，兼顧安全性、耐用性與操控品質。',
    //     //     img: require('@/assets/img/carDetails/V27/switch/7.webp'),
    //     // },
    //     // {
    //     //     id: 8,
    //     //     title: '主動安全',
    //     //     introduce: '全範圍實時監控，預判潛在風險，主動警報與幹預，實現全方位安全防護',
    //     //     img: require('@/assets/img/carDetails/V27/switch/8.webp'),
    //     // },
    // ],
    // pages: [
    //     {
    //         id: 1,
    //         title: '硬朗外觀，精准',
    //         introduce: '複古經典',
    //         img: require('@/assets/img/carDetails/V27/pages/1.jpg'),
    //         img_mobile: require('@/assets/img/carDetails/V27/pages/1.jpg'),
    //     },
    //     {
    //         id: 2,
    //         title: '科技星艦座艙，科技巨作',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V27/pages/2.jpg'),
    //         img_mobile: require('@/assets/img/carDetails/V27/pages/2.jpg'),
    //     },
    //     {
    //         id: 3,
    //         title: '可靠品質與極致享受',
    //         introduce: '',
    //         img: require('@/assets/img/carDetails/V27/pages/3.jpg'),
    //         img_mobile: require('@/assets/img/carDetails/V27/pages/3.jpg'),
    //     },
    // ],
    // switchColors: [
    //     {
    //         id: 1,
    //         title: '',
    //         introduce: '',
    //         colorBg: 'color-orange',
    //         colorText: '铜',
    //         colorBorder: '#da5301',
    //         img: require('@/assets/img/carDetails/V27/colors/1.webp'),
    //     },
    //     {
    //         id: 2,
    //         title: '',
    //         introduce: '',
    //         colorBg: 'color-white',
    //         colorText: '白',
    //         colorBorder: '#f9f9f9',
    //         img: require('@/assets/img/carDetails/V27/colors/2.webp'),
    //     },
    //     {
    //         id: 3,
    //         title: '',
    //         introduce: '',
    //         colorBg: 'color-green',
    //         colorText: '綠',
    //         colorBorder: '#b4b7bf',
    //         img: require('@/assets/img/carDetails/V27/colors/3.webp'),
    //     },
    //     {
    //         id: 4,
    //         title: '',
    //         introduce: '',
    //         colorBg: 'color-black',
    //         colorText: '黑',
    //         colorBorder: '#1c1c1c',
    //         img: require('@/assets/img/carDetails/V27/colors/4.webp'),
    //     },
    //     {
    //         id: 5,
    //         title: '',
    //         introduce: '#666',
    //         colorBg: 'color-gray',
    //         colorText: '灰',
    //         colorBorder: '#666',
    //         img: require('@/assets/img/carDetails/V27/colors/5.webp'),
    //     },
    //     {
    //         id: 6,
    //         title: '',
    //         introduce: '',
    //         colorBg: 'color-yellow',
    //         colorText: '黄',
    //         colorBorder: '#4e523b',
    //         img: require('@/assets/img/carDetails/V27/colors/6.webp'),
    //     },
    // ],
    parameters: [
        {
            specification: '車長',
            classic: '',
            premium: '5045 mm',
            flagship: '',
        },
        {
            specification: '車寬',
            classic: '',
            premium: '1976 mm',
            flagship: '',
        },
        {
            specification: '車高',
            classic: '',
            premium: '1894 mm',
            flagship: '',
        },
        {
            specification: '軸距',
            classic: '',
            premium: '2900 mm',
            flagship: '',
        },
        {
            specification: '最大功率',
            classic: '',
            premium: '100kW @5200rpm',
            flagship: '',
        },
        {
            specification: '最大扭矩',
            classic: '',
            premium: '220N·m @2500rpm',
            flagship: '',
        },
        {
            specification: '整備質量(kg)',
            classic: '2119',
            premium: '2355',
            flagship: '2355',
        },
        {
            specification: '最高車速(km/h)',
            classic: '170',
            premium: '180',
            flagship: '180',
        },
        {
            specification: '0-100km/h加速時間(s)',
            classic: '8.9',
            premium: '6.2',
            flagship: '5.9',
        },
    ],

}


export let carDetails = {
    carColumn: {
        title: '',
        list: [],
    },
    carColumn2: {
        title: '',
        list: [],
    },
    carColumn3: {
        title: '',
        list: [],
    },
    gallery: [],
    switchColors: [],
    banner: {},
    swiper: [],
    video: '',
    other: [{ id: 1, highImg: '', title: '', text: '' }]
}

export let carBannerParam27 = {
    logoImg: {
        title: '',
        logo: require("@/assets/img/v27-white.webp")
    },
    paramList: [
        { id: 1, name: 'Combined Range', value: "955 km" },
        { id: 2, name: '0~100km/h', value: "5.9s" },
        { id: 3, name: 'Horse power', value: "449" },
    ]
}

export let carBannerParam23 = {
    logoImg: {
        title: '',
        logo: require("@/assets/img/v23-white.webp")
    },
    paramList: [
        { id: 1, name: 'Wheelbase (mm)', value: "2735" },
        { id: 2, name: 'Max Power (kW)', value: "155" },
        { id: 3, name: 'Battery Volume (kWh)', value: "81.76" },
    ]
}
